export default "__VITE_ASSET__DFLIMM1P__"